export default __webpack_public_path__ + "static/media/gallery_03.e2a63b2a.jpg";